import type { clientTypes } from '@bedc/client/types';

/** Complete profiles for each supported application brand. */
export const profiles = {
	bedc: {
		name: 'ROME',
		logoAlt: 'ROME logo',
		theme: 'gold',
		themeColor: '#b59855',
	},
	carters: {
		name: 'FloKei',
		logoAlt: 'FloKei logo',
		theme: 'teal',
		themeColor: '#4d8479',
	},
} as const satisfies Record<clientTypes.brand.Id, clientTypes.brand.Profile>;
